export enum Scarcity {
	EXPIRED = 'Expired',
	NO_SCARCITY = 'NoScarcity',
	TODAY = 'Today',
	TOMORROW = 'Tomorrow',
	TWO_TO_FOURTEEN_DAYS = '2to14Days',
	NO_APPLICABLE = 'NoApplicable'
}
